export const USER_TYPE = {
  customer: 1,
  tourLeader: 2,
  accountants: 3,
  saleCounter: 4,
  generalAdmin: 5,
};

export const URL_ID = {
  mainPage: { id: 0, name: "خانه", route: "/" },
  shop: { id: 1, name: "فروشگاه", route: "/shop" },
  tours: { id: 2, name: " تور ها", route: "/tours" },
  reserveTour: { id: 3, name: "رزرو تور", route: "/reserve-tour/:id" },
  takTour: { id: 4, name: "تک تور", route: "/tak-tour/:tourId" },
  adminTourList: { id: 5, name: "لیست تور ها", route: "/admin-panel/tour-list" },
  attractions: { id: 6, name: "جاذبه ها", route: "/attractions" },
  adminCreateTour: { id: 7, name: "ساخت تور", route: "/admin-panel/create-tour" },
  adminUserManagement: { id: 8, name: "مدیریت کاربران", route: "/admin-panel/user-management" },
  adminUserReport: { id: 9, name: "گزارش کاربر", route: "/admin-panel/user-report/:edit_key" },
  adminManagement: { id: 10, name: "مدیریت", route: "/admin-panel/management" },
  adminFinancial: { id: 11, name: "امور مالی", route: "/admin-panel/financial-department" },
  adminReservation: { id: 12, name: "رزرواسیون", route: "/admin-panel/reservation" },
  customerProfile: { id: 13, name: "پروفایل", route: "/customer-panel/profile" },
  customerDashboard: { id: 14, name: "داشبورد", route: "/customer-panel/dashboard" },
  customerTransactions: { id: 15, name: "تراکنش ها", route: "/customer-panel/transactions" },
  customerOrders: { id: 16, name: "سفارشات", route: "/customer-panel/orders" },
};
